/**
 * Surveys breadcrumb origins. Built on the generic `from`-origin helpers in
 * `breadcrumbOrigin.ts`; this module only owns the Surveys-specific matcher table.
 *
 * Interior survey pages (`/surveys/:surveyId`) are reached from the My Surveys and
 * All Surveys lists. The breadcrumb roots on the page the user came from, carried in
 * the `from` query param, and falls back to All Surveys.
 */
import { type OriginMatcher, createOriginParser } from "./breadcrumbOrigin";

export { appendCurrentLocationAsFrom } from "./breadcrumbOrigin";

// Order matters: most-specific paths first.
const ORIGIN_MATCHERS: OriginMatcher[] = [
	{ match: "/surveys/my-surveys", label: "My Surveys" },
	{ match: "/surveys", label: "All Surveys" },
];

export const SURVEYS_DEFAULT_ORIGIN = { href: "/surveys", label: "All Surveys" } as const;

export type SurveysOrigin = {
	/** Internal href the root crumb links back to. */
	from: string;
	/** Display label for the originating page. */
	label: string;
};

export const parseSurveysOrigin = createOriginParser(ORIGIN_MATCHERS, SURVEYS_DEFAULT_ORIGIN);
